import trace from '~/lib/trace';
import {useState, useEffect} from 'react';
import {View, ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {
  Modal,
  Pressable,
  Text,
  ExternalLink,
  Link,
  Dialog,
} from '~/components/controls';

import {Grouping} from '~/components/controls/3';

import authentication from '~/lib/authentication';

import CloseIcon from '~/images/md-icons/close/materialicons/24px.svg';
import HelpCenterIcon from '~/images/md-icons/help_center/materialsymbolsfilled/24px.svg';
import OpenInNewIcon from '~/images/md-icons/open_in_new/materialicons/24px.svg';
import QrCode from './qr_code.svg';
import HelpIcon from '~/images/md-icons/help/materialsymbolsoutlined/24px.svg';
import ChatIcon from '~/images/md-icons/chat/materialsymbolsoutlined/24px.svg';
import PrivacyTipIcon from '~/images/md-icons/privacy_tip/materialsymbolsoutlined/24px.svg';
import PropTypes from 'prop-types';

const HelpModal = ({visible, onDismiss}) => {
  const [accessToken, setAccessToken] = useState(null);
  const [showQRCode, setShowQRCode] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      const token = await authentication.getAccessToken();
      setAccessToken(token?.split('.')[1]);
    };

    if (visible) {
      fetch().catch(trace);
    }
  }, [visible]);

  return (
    <Modal
      visible={visible}
      contentContainerStyle={sy['bg-gray95']}
      onDismiss={onDismiss}>
      <View
        style={[
          {height: 64},
          sy['flex-row'],
          sy['items-center'],
          sy['gap-8'],
          sy['bg-white'],
        ]}>
        <Pressable style={[sy['p-4']]} onPress={onDismiss}>
          <CloseIcon fill="#4a4a49" />
        </Pressable>
        <View style={[sy['flex-1'], sy['items-center'], sy['justify-center']]}>
          <Text>Support</Text>
        </View>
        <View style={[sy['p-4']]}>
          <HelpCenterIcon fill="#4a4a49" />
        </View>
      </View>
      <ScrollView
        style={[sy['bg-gray95']]}
        contentContainerStyle={[sy['p-2'], sy['gap-2']]}>
        <Grouping
          header="Support"
          icon={<HelpIcon fill="#4a4a49" />}
          initial={{expand: true}}>
          {accessToken && (
            <>
              <View style={[sy['p-4'], sy['flex-row'], sy['justify-between']]}>
                <Text>Video's & FAQ's</Text>
                <View style={[sy['flex-row'], sy['gap-4']]}>
                  <ExternalLink
                    href={`https://bahnkick.com/support/?token=${accessToken}`}
                    target="support">
                    Supportpagina
                  </ExternalLink>
                  <OpenInNewIcon fill="#4a4a49" />
                </View>
              </View>
              <Divider style={sy['bg-gray95']} />
            </>
          )}
          <View style={[sy['p-4'], sy['flex-row'], sy['justify-between']]}>
            <Text>Release notes</Text>
            <View style={[sy['flex-row'], sy['gap-4']]}>
              <ExternalLink
                href={`https://bahnkick.com/release-notes/?token=${accessToken}`}
                target="new">
                Wat is er nieuw
              </ExternalLink>
              <OpenInNewIcon fill="#4a4a49" />
            </View>
          </View>
        </Grouping>
        <Grouping
          header="Contact"
          icon={<ChatIcon fill="#4a4a49" />}
          initial={{expand: true}}>
          <View style={[sy['p-4'], sy['flex-row'], sy['justify-between']]}>
            <Text>Op dit apparaat</Text>
            <View style={[sy['flex-row'], sy['gap-4']]}>
              <ExternalLink
                href="https://wa.me/message/U62E3DXBTCIYL1"
                target="whatsapp">
                WhatsApp starten
              </ExternalLink>
              <OpenInNewIcon fill="#4a4a49" />
            </View>
          </View>
          <Divider style={sy['bg-gray95']} />
          <View style={[sy['p-4'], sy['flex-row'], sy['justify-between']]}>
            <Text>Op ander apparaat</Text>
            <View style={[sy['flex-row'], sy['gap-4']]}>
              <Link onPress={() => setShowQRCode(true)}>QR code tonen</Link>
            </View>
          </View>
          <Divider style={sy['bg-gray95']} />
          <View style={[sy['p-4'], sy['flex-row'], sy['justify-between']]}>
            <Text>Telefoonnummer</Text>
            <View style={[sy['flex-row'], sy['gap-4']]}>
              <ExternalLink href="tel:+31207233638" target="_self">
                +31 (0)20 723 36 38
              </ExternalLink>
            </View>
          </View>
        </Grouping>
        <Grouping
          header="Voorwaarden"
          icon={<PrivacyTipIcon fill="#4a4a49" />}
          initial={{expand: true}}>
          <ExternalLink
            href="https://bahnkick.blob.core.windows.net/signin/20240716_Bahnkick Gebruiksvoorwaarden (EULA).pdf"
            textStyle={[sy['no-underline']]}>
            <View
              style={[
                {display: 'flex'},
                sy['p-4'],
                sy['flex-row'],
                sy['justify-between'],
              ]}>
              <Text>Bahnkick gebruiksvoorwaarden</Text>
              <OpenInNewIcon fill="#4a4a49" />
            </View>
          </ExternalLink>
        </Grouping>
      </ScrollView>
      <Dialog
        title="QR code WhatsApp"
        visible={showQRCode}
        options={{noPaddingContent: true}}
        dismissable
        onDismiss={() => setShowQRCode(false)}
        buttons={[
          {
            text: 'Sluiten',
            onPress: () => setShowQRCode(false),
          },
        ]}>
        <View style={[sy['flex-1'], sy['p-4'], sy['gap-4']]}>
          <Text>Scan deze code om een WhatsApp-chat met ons te beginnen.</Text>
          <View style={[sy['items-center']]}>
            <QrCode />
          </View>
        </View>
      </Dialog>
    </Modal>
  );
};
HelpModal.propTypes = {
  visible: PropTypes.any,
  onDismiss: PropTypes.any,
};

export default HelpModal;
